import React, { useState } from "react";
import {BsCheckBox} from 'react-icons/bs'
import {VscDebugContinue} from 'react-icons/vsc'
import {HiOutlineLockClosed} from 'react-icons/hi'
const goalData = [
  {
    id: 1,
    name: "Entering university",
    info: "Math, English, Pyhisics",
    reason:
      "I want to make many friends and want that I have environment in programming",
    done: 1,
    delay: 100,
    isDone: <BsCheckBox />,
  },
  {
    id: 2,
    name: "Being full-stack developer",
    info:
      "Html, css, scss, bootstrap, javascript, reactjs, nodejs, express, mongoDB",
    reason:
      "I will learn how to work and I will earn money for going to abroad for styding and during styding abroad I will earn money for living and for future 'Technolife' kompany",
    done: 0,
    delay: 300,
    isDone: <VscDebugContinue />,
  },
  {
    id: 3,
    name: "Deep Learning abroad",
    info: "Python, Harvard Education, Work of companies",
    reason:
      "I will learn many things during foreign styding such as education, new technologies for making life easily, famous companies' works",
    done: -1,
    delay: 500,
    isDone: <HiOutlineLockClosed />,
  },
  {
    id: 4,
    name: "Creating TechnoLife company",
    info: "Developing IT in Uzbekistan, Living well",
    reason:
      "One of my goals is contributing in the future of Uzbekistan in many fiels especially IT, education, business and others and I want to live well my future family",
    done: -1,
    delay: 700,
    isDone: <HiOutlineLockClosed />,
  },
  {
    id: 5,
    name: "Marrying the best saliha muslim girl",
    info:
      "Reading Quran two times, Acquaring enough religious knowledge, Being ready for children rearing",
    reason:
      "I want to the best family in the world that can be an example to others and I will bring up the most brave, smartest muslim guys and girls, I want that my wife will be the happiest woman in the world with me",
    done: -1,
    delay: 700,
    isDone: <HiOutlineLockClosed />,
  },
];

const Goals = () => {
  const [open, setOpen] = useState([false, false, false, false, false]);
  const visible = (id) => {
    let newArr = [...open];
    newArr[id - 1] = !open[id - 1];
    setOpen(newArr);
  };
  return (
    <div className="goals">
      <div className="commonBox">
        <h1>My Goals</h1>
        <div className="common"></div>
      </div>
      <div className="goalsInner">
        {goalData.map((item) =>
          item.id % 2 === 1 ? (
            <div
              className="goal"
              key={item.id}
              data-aos="fade-up"
              data-aos-delay={item.delay}
            >
              <div className="goalName">
                <h1>
                  <button onClick={() => visible(item.id)}>
                    <div className={"goal" + item.done}>{item.isDone}</div>
                    {item.name}
                  </button>
                </h1>
              </div>
              <div className="goalNumber">
                <div className="number">
                  <p className={"number" + item.done}>{item.id}</p>
                </div>
              </div>
              <div
                className={
                  open[item.id - 1] ? "goalInfo visible" : "goalInfo hidden"
                }
              >
                <p className="learnThings">{item.info}</p>
                <p className="reason">{item.reason}</p>
              </div>
            </div>
          ) : (
            <div
              className="goal"
              key={item.id}
              data-aos="fade-up"
              data-aos-delay={item.delay}
            >
              <div
                className={
                  open[item.id - 1] ? "goalInfo visible" : "goalInfo hidden"
                }
              >
                <p className="learnThings">{item.info}</p>
                <p className="reason">{item.reason}</p>
              </div>
              <div className="goalNumber">
                <div className="number">
                  <p className={"number" + item.done}>{item.id}</p>
                </div>
              </div>
              <div className="goalName">
                <h1>
                  <button onClick={() => visible(item.id)}>
                    <div className={"goal" + item.done}>{item.isDone}</div>
                    {item.name}
                  </button>
                </h1>
              </div>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default Goals;
